<button type="button"
        onclick="let cs = this.parentElement.getElementsByClassName('catalog-selector')[0]; cs.open ? cs.close(): cs.show();"
        [style.--svg]="currentSvg"
        svg
        [attr.aria-label]="'CATALOG_SELECTOR.SELECT_CATALOG' | translate:{current:current}">
</button>
<dialog class="catalog-selector">
    @for (catalog of catalogs; track $index) {
        <label
        [style.--svg]="catalog.svg"
        svg
        >
            <input type="radio"
            oninput="window.location.href = value"
            name="catalog"
            [checked]="catalog.checked"
            [attr.value]="catalog.url">
            <span>{{'CATALOG_SELECTOR.'+catalog.translate | translate}}</span>
        </label>
    }
</dialog>
